<template>
  <div class="wind-bulb-signal">
    <el-dialog title="风球信号" :visible.sync="params.flag" v-dialogDrag :modal="false" :close-on-click-modal="false"
      :lock-scroll="false" :modal-append-to-body=false ref="remRef"
      :before-close="() => params.flag && $parent.toggleProductView(params.productInfo.code)">
    <template slot="title">
      <div class="title-box">
        <div class="title">风球信号</div>
        <div class="public-time">风球信号发布时间:  {{ windballPTime }}</div>
      </div>
    </template>
    <div class="content-box">
      <img src="@/assets/images/bgimg.jpg" alt="">
      <div class="info-panel">
        <div class="msg">
          <span v-html="windballInfo"></span>
        </div>
        <div class="tuli">
          <span style="margin-right: 1.04vw;">图例:</span>
          <span>强风</span>
          <img src="../assets/images/wind.gif" alt="">
          <span>台风</span>
          <img src="../assets/images/typhoon (1).gif" alt="">
        </div>
        <div class="tip">
          <div class="ul">
            <li>
              <span style="color: red;">风球区域划分</span>
            </li>
            <li style="color: #28a0e5; text-align: center;">
              <span style="box-sizing: border-box;border-right: 1px solid #82C7DF;width: 40%;">港区</span>
              <span style="width: 60%;">描述</span>
            </li>
            <li class="item" v-for="item in tuliData" :key="item.name">
              <span class="item-left">
                <span :style="{ background: item.color }"></span>
                <span>{{ item.area }}</span>
              </span>
              <span><span>{{ item.des }}</span></span>
            </li>

          </div>
        </div>
      </div>

      <div class="fqwrap" v-for="(item, index) in tuliData" :key="item.area" :style="`left:${item.left};top:${item.top};`">
        <div class="fqwrap-item" v-for="element in item.windball" :key="element.num">
          <div class="imgdiv">
            <img class="icon" port="one" :src="
              require('../assets/images/' +
                element.icon +
                '.png')
            " /><span class="wblev">{{ element.num }}</span>
          </div>
          <div class="cont">
            {{ index + 1 }}号区:<br />{{ iconTitle
            }}{{ element.level }}号风球
          </div>
        </div>
      </div>

     <div class="message">{{ relieveWindBall }}</div>
    </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiData } from '../api/index'
export default {
  props: ['params'],
  data () {
    return {
      relieveWindBall: '',
      windballInfo: '',
      windballPTime: '',
      tuliData: [
        { area: '1号区', des: '桂山岛到内伶仃岛', color: '#dfa541', left: '40%', top: '75%', windball: [] },
        { area: '2号区', des: '内伶仃岛到虎门大桥', color: '#f3b954', left: '36%', top: '45%', windball: [] },
        { area: '3号区', des: '虎门大桥到黄埔大桥', color: '#ffde6a', left: '26%', top: '16%', windball: [] },
        { area: '4号区', des: '黄埔大桥以内', color: '#fef49e', left: '11%', top: '6%', windball: [] }
      ]
    }
  },
  watch: {
    'params.flag': {
      handler (flag) {
        flag && this.setZindex()
      },
      immediate: true
    }
  },
  created () {
    this.getWindBball()
  },
  methods: {

    async getWindBball () {
      const res = await apiData.getWindBball()
      // 解除风球信号或无风球信号
      if (res.ports === '0000') {
        var now = new Date().getTime()
        if (res.cont.indexOf('解除') > 0 && now - res.time >= 3600000 * 6) {
          this.relieveWindBall = '当前无风球信号'
        } else {
          this.relieveWindBall = res.cont
        }
      } else {
        this.tuliData.forEach((item, index) => {
          console.log('====', this.tuliData, res.levels[index])
          if (res.levels[index][0] > 0) {
            // console.log(res.levels[item])
            this.iconTitle = '强风信号'
            const data = { icon: '强风风球', num: this.getNumber(res.levels[index][0]), level: res.levels[index][0] }
            this.tuliData[index].windball.push(data)
          }
          if (res.levels[index][1] > 0) {
            this.iconTitle = '台风信号'
            const data = { icon: '台风风球', num: this.getNumber(res.levels[index][1]), level: res.levels[index][1] }
            this.tuliData[index].windball.push(data)
          }
        })
        if (res.cont.length === 0) {
          this.relieveWindBall = '当前无风球信号'
        }
      }
      const windballInfo = this.relieveWindBall === '' ? res.cont : this.relieveWindBall
      this.windballInfo = windballInfo.replace(/。/g, '。<br/>')
      if (this.relieveWindBall === '当前无风球信号') {
        this.windballPTime = '-'
      } else {
        this.windballPTime = this.$moment(res.time).format('yyyy年MM月DD日HH时mm分')
      }
      this.windballPTime = this.$moment(res.time).format('yyyy年MM月DD日HH时mm分')
    },

    getNumber (num) {
      switch (num) {
        case 1:
          return '①'
        case 2:
          return '②'
        case 3:
          return '③'
        case 4:
          return '④'
        case 5:
          return '⑤'
        case 6:
          return '⑥'
      }
    },

    // 设置弹出框的zIndex
    setZindex () {
      this.$nextTick(() => {
        const el = this.$refs.remRef
        let zIndex = JSON.parse(localStorage.getItem('dialogZIndex'))
        zIndex = zIndex * 1 + 1
        el.$el.style.zIndex = zIndex
        localStorage.setItem('dialogZIndex', JSON.stringify(zIndex))
      })
    }
  }

}
</script>
<style lang="less" scoped>
.wind-bulb-signal {
  display: flex;
  flex-direction: column;
  pointer-events: none;
  .content-box{
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    img{
      height: 100%;
    }
    .info-panel{
      position: absolute;
      top: 1.04vw;
      right: 1.04vw;
      .msg{
        min-height: 2.6vw;
        margin-bottom: 1.56vw;
        padding: 5px 10px;
        box-sizing: border-box;
        font-size: 0.84vw;
        border: 0.05vw solid #82C7DF;
        background-color: rgba(238, 237, 145, 0.76);
      }
      .tuli, .tip{
         border: 0.05vw solid #82C7DF;
         background-color: rgba(248, 250, 249, 0.78);
         padding: 0.52vw 0.52vw;
         font-size: 0.43vw;
        li {
            width: 16.58vw;
            height: 1.56vw;
            display: flex;
            justify-content: space-between;
            align-items: center;
            list-style: none;
            text-align: center;
            border-bottom: 0.05vw solid #82C7DF;
            border-right: 0.05vw solid #82C7DF;

            >span {
              width: 100%;
              height: 100%;
              // line-height: 30px;
            }
          }
      }
       .tuli{
        display: flex;
        align-items: center;
         border-bottom: 0;
         img{
          width: 0.93vw;
          margin: 0.42vw;
         }
       }
      .tip{
        border-top: 0;
        text-align: center;
        .ul{
          margin: 0vw auto ;
          background: #fff;
          border-top: 0.05vw solid #82C7DF;
          border-left: 0.05vw solid #82C7DF;
            .item{
              >span {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  width: 60%;
                  height: 100%;
                  box-sizing: border-box;
                  padding: 0 0.52vw;
                  &:nth-child(1){
                    width: 40%;
                  }
                }

                .item-left {
                  box-sizing: border-box;
                  border-right: 0.05vw solid #82C7DF;
                  span:nth-child(1) {
                    width: 1.04vw;
                    height: 1.04vw;
                  }
                }
            }
        }
      }
    }
    .message{
      position: absolute;
      top: 30%;
      left: 25%;
      padding: 0.46vw;
      font-size: 1.15vw;
      font-weight: 600;
      border: 0.05vw solid #82C7DF;
      border-radius: 0.26vw;
      background: rgba(67, 67, 65, 0.26);
    }

        .fqwrap {
          position: absolute;

          .fqwrap-item {
            display: flex;
            align-items: center;
            font-weight: 600;
            font-size: 0.875rem;

            .imgdiv {
              display: flex;
              align-items: center;

              img {
                height: 1.8rem;
              }

              .wblev {
                font-size: 1.2rem;
                margin: 0 0.2rem;
              }
            }
          }
        }

        .public-time{
          position: absolute;
          top: -20px;
          right: 70px;
        }
  }

  /deep/.el-dialog__wrapper {
    overflow: hidden;

    .el-dialog {
      width: 95vh;
      height: 87vh;
      margin-top: 2vh !important;
      pointer-events: auto;

      .el-dialog__body{
        overflow: hidden;
      }
    }
  }
}

.title-box{
  display: flex;
  justify-content: space-between;
  color: #FFF;
  font-size: 0.83vw;
  .title{
    font-size: 0.94vw;
    font-weight: 600;
    color: #FFF;
  }
  .public-time{
    margin-right: 1.56vw;
  }
}
</style>
